// (C) 2020 The MITRE Corporation. All Rights Reserved.
import 'bulma/css/bulma.css'
import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')
